import classNames from "classnames";
import type React from "react";
import { useEffect, useState } from "react";
import { useDebounce } from "../../utils/customHook.util";
import "./SearchFilter.css";
import { Flex } from "./Flex";
import Icon from "./Icon";

type Props = {
    onChange: (search: string) => void;
    throttle?: number;
    className?: string;
    placeholder?: string;
};

const InputSearch = function InputSearch(props: Props) {
    const { className, throttle, onChange, placeholder } = props;
    const [value, setValue] = useState<string>("");
    const debouncedValue = useDebounce<string>(value, throttle || 200);

    useEffect(() => {
        onChange(debouncedValue);
    }, [debouncedValue]);

    const onSearchTermChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        if (value !== newValue) {
            setValue(newValue);
        }
    };

    const reset = () => {
        setValue("");
    };

    return (
        <div className={classNames("search-filter", className)}>
            <Icon.Search.Small className="search-filter__icon" />
            <input
                type="text"
                value={value}
                placeholder={placeholder}
                onChange={onSearchTermChange}
            />
            {value.length > 0 && (
                <Flex.Row
                    className="search-filter__matches"
                    justifyContent="end"
                    onClick={reset}
                >
                    <div>
                        <Flex.Row>
                            <Icon.Close.Small />
                        </Flex.Row>
                    </div>
                </Flex.Row>
            )}
        </div>
    );
};

export default InputSearch;
